// extracted by mini-css-extract-plugin
export default {"button":"icon-button_button__ZkLOi","fill":"icon-button_fill__zVh0r","small":"icon-button_small__mxwsv","medium":"icon-button_medium__ZFLG3"};